import type { LinkProps } from 'next/link';
import Link from 'next/link';

import type AppMarketHomeLink from '~/layouts/AppMarketHomeLink';

type Props = LinkProps & React.ComponentProps<typeof AppMarketHomeLink>;

const LegacyLinkComponent = ({ children, href, ...props }: Props) => {
  return (
    <Link {...props} href={href} legacyBehavior>
      {children}
    </Link>
  );
};

export default LegacyLinkComponent;
